import React from "react";
import loadable from "@loadable/component";
import routes from "../../routes.json";
import LoadingPage from "../../components/layout/loading/page/loadingPage";

/*
	About
		- Adds all the components dynamically
		- The string `../../` changes directory to ./pages to get all component
		  - This cannot be a const (webpack issue)
*/

const PageComponents: any = [];
const landingPageRoute = { path: "/", component: "pages/index" }; // TODO: Temp fix, need to update webdemo-cli to include landing page
const allRoutes = [...routes, landingPageRoute];

allRoutes
	.filter((route) => {
		return !route.path.includes("customize");
	})
	.forEach((route) => {
		const LoadableComponent = loadable(
			() =>
				import(
					`../../${route.component}`
				) /*Fix(webpack): need starting string*/,
			{
				fallback: <LoadingPage id="pages-loading" />,
			},
		);
		PageComponents.push({ path: route.path, component: LoadableComponent });
	});

export default PageComponents;
